<template>
	<div class="panel_shouyin">
		<!-- <div class="titleLine">
			<el-row>
				<el-col :span="2" :offset="22">
				</el-col>
			</el-row>
		</div> -->
		<div class="listLine">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="住院单号" prop="id">
					<template slot-scope="props">
						<span @click="toZhuyuanSee(props.row)" style="color:#1890FF;cursor: pointer;text-decoration: underline;">{{props.row.id}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column label="顾客" prop="memberName">
				</el-table-column>
				<el-table-column label="手机号" prop="memberMobile" width="110">
				</el-table-column>
				<el-table-column label="昵称" prop="petName">
				</el-table-column>
				<el-table-column label="品种" prop="typeName">
				</el-table-column>
				<el-table-column label="年龄" prop="birthDay" width="80">
					<template slot-scope="props">
						<div v-if="props.row.birthDay&&props.row.birthDay.length>4">
							{{$public.FAge(new Date(props.row.birthDay).getTime())[0]}}年{{$public.FAge(new Date(props.row.birthDay))[1]}}月
						</div>
					</template>
				</el-table-column> -->
				<el-table-column label="经办人" width="100">
					<template slot-scope="props">
						<div>{{props.row.handlerName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="时间" width="200">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.beginDate,'YYYY/MM/DD')}}-{{$public.FTime(props.row.endDate,'YYYY/MM/DD')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="时长" width="150">
					<template slot-scope="props">
						<div>{{props.row.inHospitalDuration}}</div>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" width="200">
					<template slot-scope="props">
						<div>{{$public.FTime(props.row.createTime,'YYYY/MM/DD HH:mm')}}</div>
					</template>
				</el-table-column>
				<el-table-column label="住院情况" width="100">
					<template slot-scope="props">
						<div v-if="props.row.payInfo.payCount===0">
							<div style="color:red">未支付</div>
						</div>
						<div v-else>
							<div style="color:#18A44C">{{props.row.status==1?'住院中':''}}</div>
							<div style="color:#B7B7B7">{{props.row.status==2?'已离院':''}}</div>
						</div>
					</template>
				</el-table-column> 
				
				<el-table-column label="状态" width="100">
					<template slot-scope="props">
						<span v-if="props.row.consumeMoney>props.row.deposit" style="color:red">已欠费</span>
						<span v-else>
							<span v-if="props.row.payInfo&&props.row.payInfo.payCount==0" style="color:#B05B12">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
							<span v-if="props.row.payInfo&&props.row.payInfo.payCount>0" style="color:#18A44C">{{props.row.payInfo.payCount}}/{{props.row.payInfo.total}}</span>
						</span>
					</template>
				</el-table-column>
				
				<!-- <el-table-column label="操作" width="280">
					<template slot-scope="props">
						<el-button type="text" size="mini" @click="$router.push({path:'/yiliao/zhuyuanSee?id='+props.row.id})">查看</el-button>
					</template>
				</el-table-column> -->
				<span slot="empty">
					<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
					<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
				</span>
			</el-table>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<bingliSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @close="submit_drawerJiyangPetSee"></bingliSee>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import bingliSee from "../drawer/bingliSee.vue"
	export default {
		components:{page,bingliSee},
		data(){
			return{
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				// seePet
				drawerJiyangPetSee_state:false,
				curItem:{}
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			zhuyuanParams(){
				return this.$store.state.yiliaoxin.zhuyuanParams;
			},
		},
		watch:{
			curPetInfo(){
				this.getTableData()
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			toZhuyuanSee(row){
				let index = "/yiliaoxin"
				let str = "医疗工作台"
				this.$store.commit("setCurNavIndex_"+index.split('/')[1],{title:str,path:index})
				this.$router.push({path:index})
				
				this.zhuyuanParams.curRow = row
				this.zhuyuanParams.type = 'see'
				this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
				this.$store.commit('yiliaoxin/set_curBusiness','住院')
			},
			seePet(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
			},
			changePage(num){
				this.page.page = num;
			},
			// 获取寄养列表
			getTableData() {
				let loading=this.$loading();
				let params = {
					"keyword":'',
					"petId": this.curPetId,
					"memberId": "",
					"status": 0, // 0不限；1：住院中；2：已离院
					isPay:-1,  // （-1不限：0未支付；1：已支付）
					"depositType": 0,  // (0不限；1：押金；2：余额)
					"startTime": "",
					"endTime": "",
					"desc": true,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				// if(this.datetimerange&&this.datetimerange.length==2){
				// 	params.begin_time=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
				// 	params.end_time=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				// }
				console.log(params)
				this.$http.post('/api/InHospital/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:0 0 0;box-sizing: border-box;position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:8px 8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		position: absolute;
		top:0;
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
